"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExchangeRates = void 0;
const getExchangeRates = async (supabase) => {
    const { data, error } = await supabase.from("exchange_rates").select(`*`);
    if (!error)
        return data;
    return error;
};
exports.getExchangeRates = getExchangeRates;
